export default __webpack_public_path__ + "static/step2-e8ad8624f48527b9820fd7d647170967.png";